import { render, staticRenderFns } from "./TemporaryItemModal.vue?vue&type=template&id=21137002&scoped=true"
import script from "./TemporaryItemModal.vue?vue&type=script&lang=js"
export * from "./TemporaryItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21137002",
  null
  
)

export default component.exports